var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1599 16.2245V18.9588C26.1599 19.41 25.7908 19.7792 25.3396 19.7792H17.4099V24.3592C17.4099 25.0907 16.5281 25.453 16.0085 24.9403L9.24097 18.1727C8.91968 17.8514 8.91968 17.3319 9.24097 17.0106L16.0085 10.243C16.5281 9.72349 17.4099 10.0926 17.4099 10.8241V15.4042H25.3396C25.7908 15.4042 26.1599 15.7733 26.1599 16.2245Z",
    fill: "#364A5E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.35,
    stroke: "#364A5E",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitTest);
export default __webpack_public_path__ + "static/media/exitTest.6b0f7490def036a210e3595f655b0e2e.svg";
export { ForwardRef as ReactComponent };